import { Link } from 'react-router-dom'
import { ChevronLeft } from '@/components/ui/primitives'

export function NotFound() {
  return (
    <div className="flex flex-col items-start gap-4 py-20">
      <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-accent">404</p>
      <h1 className="text-2xl font-semibold">That page does not exist</h1>
      <p className="max-w-md text-[13px] text-muted">
        The link may be from an older version of the portal, or it may point at something
        that belongs to another partner.
      </p>
      <Link
        to="/"
        className="brand-gradient inline-flex h-10 items-center gap-2 rounded-md px-4 text-sm font-medium text-white"
      >
        <ChevronLeft />
        Back to your deals
      </Link>
    </div>
  )
}
